import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=fe3381a6&"
import script from "./accept.vue?vue&type=script&lang=js&"
export * from "./accept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports